<template>
  <div>
    <h1 class="p-5 text-uppercase">Preisliste</h1>

    <div class="row">
      <div class="col-sm-8 offset-lg-2 accordion">
        <button class="w-100 price-expand" @click="expand('events')">
          Events, Hochzeiten, Geburtstage, Firmenfeiern, Konfirmation, Party
        </button>
        <div class="collapsible text-left" v-show="open.events">
          <div class="pt-3"><p>Beinhaltet alle Rechte an den gemachten Aufnahmen, die sie spätestens 14 Tage nach der
            Veranstaltung per geschütztem Downloadlink in höchst möglicher Auflösung erhalten, den sie bei
            Bedarf an die Gäste weitergeben möchten. Auf Wunsch auch auf USB-Stick oder BlueRay/DVD. Alles
            was anliegt und gewünscht wird, wird fotografiert, alles inklusive (Paarshooting, Gruppenbilder usw.)
            Drohneneinsatz inklusive, insofern gewünscht und erlaubt!</p></div>
          <div class="row">
            <div class="col-sm-9">
              <div class="row pt-3">
                <div class="col-9">
                  Stundensatz vor Ort (anschließende Bildnachbearbeitung inkl.)
                </div>
                <div class="col-3 text-right">
                  100,- €
                </div>
              </div>
              <div class="row">
                <div class="col-9">
                  Rüstpauschale:
                  <small>entfällt ab einer Einsatzzeit von 4 Std</small>
                </div>
                <div class="col-3 text-right">50,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale Region Hannover:
                </div>
                <div class="col-3 text-right">0,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale:
                  <small>je gefahrener Kilometer</small>
                </div>
                <div class="col-3 text-right">30 ct</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  Fotobuch mit 26 Seiten im Hardcover nicht vom Discounter A4 quer, Layflat Bindung:
                </div>
                <div class="col-3 text-right">90,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  je weitere 12 Seiten <small>(andere Formate auf Anfrage)</small>
                </div>
                <div class="col-3 text-right">30,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Video- Diashow je 10 Minuten:
                </div>
                <div class="col-3 text-right">90,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Je weitere 5 Minuten:
                </div>
                <div class="col-3 text-right">40,- €</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  Mobiles Fotostudio vor Ort: <br>
                  <small>- professioneller Hintergrund <br>
                    - Studiobeleuchtung <br>
                    - Assessors, Requisiten <br>
                    - Möglichkeit alle Gäste in hervorragender Qualität bzw. witzig abzulichten. Somit sind
                    Gästebilder in Studioqualität möglich und möglicher Ersatz für eine Fotobox.</small>
                </div>
                <div class="col-3 text-right">90,- €</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  <b>Tagespauschale beinhaltet alle obigen Leistungen, wie:</b> <br>
                  <small> Fotobuch, Video- Diashow, Mobiles Fotostudio</small>
                </div>
                
              </div>
              

              <div class="row pt-3">
                <div class="col-9">
                  Begleitung der Veranstaltung von Beginn (Getting Ready) bis Partyende 12 Std.
                </div>
                <div class="col-3 text-right">1200,- €</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  Begleitung der Veranstaltung vom Begin (Getting Ready) bis Partyende 16 Std.
                </div>
                <div class="col-3 text-right">1400,- €</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  Begleitung der Veranstaltung vom Begin (Getting Ready) bis Partyende ohne Zeitlimit.
                </div>
                <div class="col-3 text-right">1600,- €</div>
              </div>
              <div class="row pt-3">
                <div class="col-9">
                  Fotobox inkl. Druck:
                </div>
                <div class="col-3 text-right">300,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Fotografenassistenz je Stunde:
                </div>
                <div class="col-3 text-right">50,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Fotografenassistenz von Beginn (Getting Ready) bis Partyende 12 Std.:
                </div>
                <div class="col-3 text-right">500,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Fotografenassistenz von Beginn (Getting Ready) bis Partyende 16 Std.:
                </div>
                <div class="col-3 text-right">600,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Fotografenassistenz von Beginn (Getting Ready) bis Partyende ohne Zeitlimit:
                </div>
                <div class="col-3 text-right">700,- €</div>
              </div>

            </div>
            <div class="col-sm-3 text-center pt-3 pb-4">
              <img src="https://wernicke-foto.de/bilder/preisliste/hochzeit01.jpg"  class="pb-2" alt="" width="90%">
              <img src="https://wernicke-foto.de/bilder/preisliste/hochzeit02.jpg" alt="" width="90%">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-2 accordion">
        <button class="w-100 price-expand" @click="expand('studio')" >
          Studiofotografie, on Location, oder Daheim
        </button>
        <div class="collapsible text-left" v-show="open.studio">
          <div class="pt-3">
            <p>Familienbilder, Paarbilder, Kinder, Portraits, Erotik, Action, Baby, Babybauch</p>
            <p>Beinhaltet alle Rechte an den gemachten Aufnahmen, die Sie nach dem Shooting
              per geschütztem Downloadlink oder per E-Mail in höchst möglicher Auflösung erhalten. 
              <br>
              Drohneneinsatz on Location inklusive, insofern gewünscht und erlaubt!</p>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <div class="row pt-3">
                  <div class="col-9">
                    Stundensatz vom Shooting (anschließende Bildnachbearbeitung inkl.): <br>
                    
                  </div>
                  <div class="col-3 text-right">100,- €</div>
                </div>
                <div class="row pt-3">
                <div class="col-9">
                  <b>Tagespauschale 8 Std.</b> <br>
                  <br>
                  On Location:
                </div>
                <div class="col-3 text-right">700,- €</div>
                
              </div>
             
             
                <div class="row">
                <div class="col-9">
                  Rüstpauschale:
                  <small>entfällt ab einer Einsatzzeit von 4 Std</small>
                </div>
                <div class="col-3 text-right">50,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale Region Hannover:
                </div>
                <div class="col-3 text-right">0,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale:
                  <small>je gefahrener Kilometer</small>
                </div>
                <div class="col-3 text-right">30 ct</div>
              </div>
                <br>
                <div class="row">
                  <div class="col-9">
                    Fotobuch mit 26 Seiten im Hardcover nicht vom Discounter A4 quer, Layflat Bindung:
                  </div>
                  <div class="col-3 text-right">90,- €</div>
                </div>
                <div class="row">
                  <div class="col-9">
                    weitere 12 Seiten <small>(andere Formate auf Anfrage)</small>
                  </div>
                  <div class="col-3 text-right">30,- €</div>
                </div>

              </div>
              <div class="col-sm-3 text-center pt-1 pb-4">
                <img src="https://wernicke-foto.de/bilder/preisliste/studio01.jpg" alt="" width="90%">
              </div>
            </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-2 accordion">
        <button class="w-100 btn-outline-dark btn-block price-expand" @click="expand('application')">
          Bewerbungsfotos
        </button>
        <div class="collapsible text-left" v-show="open.application">
          <div class="pt-3">Beinhaltet Vorgespräch und alle Rechte an den gemachten Aufnahmen, die Sie am selben Tag nach dem Shooting per
            geschütztem Downloadlink oder per E-Mail in höchst möglicher Auflösung erhalten.</div>
            <div class="row">
              <div class="col-sm-9">
                <div class="row pt-3">
                  <div class="col-9">
                    Shooting je 30 Min. im Studio oder on Location:
                  </div>
                  <div class="col-3 text-right">50,- €</div>
                </div>
                <br>
                On Location: <br>
                <div class="row">
                <div class="col-9">
                  
                  Rüstpauschale:
                  <small>entfällt ab einer Einsatzzeit von 4 Std</small>
                </div>
                <div class="col-3 text-right">50,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale Region Hannover:
                </div>
                <div class="col-3 text-right">0,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale:
                  <small>je gefahrener Kilometer</small>
                </div>
                <div class="col-3 text-right">30 ct</div>
              </div>
                <div class="row">
                  <div class="col-9">
                    8 Stück Papierabzüge (Lieferung am nächsten Werktag zur Post)
                  </div>
                  <div class="col-3 text-right">40,- €</div>
                </div>
              </div>
              <div class="col-sm-3 text-center pt-1 pb-4">
                <img src="https://wernicke-foto.de/bilder/preisliste/bewerbung01.jpg" alt="" width="90%">              
              </div>
            </div>

        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-2 accordion">
        <button class="w-100 btn-outline-dark btn-block price-expand" @click="expand('buildings')">
          Immobilienfotografie
        </button>
        <div class="collapsible text-left" v-show="open.buildings">
          <div class="pt-3">Beinhaltet alle Rechte an den gemachten Aufnahmen, die sie spätestens 4 Tage nach dem Shooting
            per geschütztem Downloadlink oder per E-Mail in höchst möglicher Auflösung und im gewünschtem
            Format erhalten. Ich arbeite mit unterschiedlichen Immobilienmaklern (Mc Makler, Realbest, My
            Photoagency uvm. ) zusammen. </div>
            <div class="row">
              <div class="col-sm-9">
                <div class="row pt-3">
                  <div class="col-9">
                    Grundbetrag Immobilie bis zu 5 Räumen (Bildnachbearbeitung inkl.):
                    
                  </div>
                  <div class="col-3 text-right">120,- €</div>
                </div>
                
                <div class="row pt-3">
                  <div class="col-9">
                    Je weitere 5 Räume
                  </div>
                  <div class="col-3 text-right ">90,- €</div>
                </div>
                <div class="row pt-3">
                  <div class="col-9">
                    Drohneneinsatz inkl. 5 Luftbilder:
                  </div>
                  <div class="col-3 text-right">70,- €</div>
                </div>
                <div class="row">
                  <div class="col-9">

                  </div>
                  <div class="col-3 text-right"></div>
                </div>
                
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale Region Hannover:
                </div>
                <div class="col-3 text-right">0,- €</div>
              </div>
              <div class="row">
                <div class="col-9">
                  Anfahrtspauschale:
                  <small>je gefahrener Kilometer</small>
                </div>
                <div class="col-3 text-right">30 ct</div>
              </div>
              </div>
              <div class="col-sm-3 text-center pt-1 pb-4">
                <img src="https://wernicke-foto.de/bilder/preisliste/immobilie01.jpg" alt="" width="90%">
              </div>
            </div>

        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-2 accordion">
        <button class="w-100 btn-outline-dark btn-block price-expand" @click="expand('products')">
          Produktfotografie
        </button>
        <div class="collapsible text-left" v-show="open.products">
          <div class="pt-3">
            <div class="row">
              <div class="col-sm-9">
                Beinhaltet alle Rechte an den gemachten Aufnahmen, die per geschütztem
                Downloadlink oder per E-Mail in höchst möglicher Auflösung und im gewünschtem
                Format erhalten. Hier sind die Aufwände je nach Auftrag sehr unterschiedlich. Bei
                mehreren
                Produkten fängt
                der Preis bei 30
                € / Bild an.
              </div>
              <div class="col-sm-3 text-center pt-1 pb-4">
                <img src="https://wernicke-foto.de/bilder/preisliste/produkt01.jpg" alt="" width="90%">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Preise",
    data() {
      return {
        open: {
          events: false,
          studio: false,
          application: false,
          buildings: false,
          products: false
        }
      }
    },
    methods: {
      expand(id) {
        this.open[id] = !this.open[id]
      }
    }
  }
</script>

<style scoped lang="scss">
  @media(min-width: 960px) {
    .accordion {
      padding: 0 3rem 1rem;
    }
  }
  @media (min-width: 340px) {
    .accordion {
      padding: 0 1rem 1rem;
    }

  }
  .collapsible {
    overflow: hidden;
    //display: none;
    padding: 0 18px;
    background-color: #eae6ea;
    /*transform:scaleY(0);*/
    transition: all .35s ease;
    //max-height: 0;
  }
  .price-expand {
    padding: 18px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    -moz-border-radius-topleft: 5px;
    -moz-border-radius-topright: 5px;
    display: flex;
    text-align: left;
    justify-content: space-between;
    transition: all .35s;
    /*transform:scaleY(1);*/
    /*transition:transform 0.3s ease-out;*/
    &::after {
      content: "\276F";
      width: 1em;
      height: 1em;
      text-align: center;

    }
    &:hover {
      background: darken(#cdcdcd, 60%);
      color: #fff;
    }
  }
</style>